<!--Element单选树形控件-->
<template>
  <div class="el_Tree_Body" :style="bodyStyle">
    <!-- style="padding-bottom: 50px;padding-top: 30px;" -->
    <!-- <div class="elTree_hideButton">
			<div class="elTree_hideButton1" v-show="isShow" @click="isShow=!isShow">
				<el-button size="mini" icon="iconfont iconleft_shousuo"></el-button>
			</div>
			<div class="elTree_hideButton2" v-show="!isShow" @click="isShow=!isShow">
				<el-button size="mini" icon="iconfont iconrigth_shousuo"></el-button>
			</div>
		</div> -->
    <transition name="el-zoom-in-center">
      <div v-show="isShow" class="elTree_body">
        <div style="display: flex;padding-top:10px;align-items: center;" class="search-input">
          <el-input placeholder="输入关键字进行过滤" v-model="filterText" size="small" style='width: 180px;margin-left: 15px;'>
          </el-input>
        </div>
        <div class="scroll" style="height:93%;width: 100%;">
          <el-scrollbar style="height:100%;width: 100%;">
            <!-- :default-checked-keys=[1]  -->
            <el-tree :data="data" :accordion="true" :default-expanded-keys="defaultExpanded"
              :current-node-key='defaultDevice' :expand-on-click-node="true" node-key="pkid" :props="defaultProps"
              :highlight-current='true' :filter-node-method="filterNode" ref="tree" @node-click="nodeClick">
              <span class="custom-tree-node" slot-scope="{node}">
                <img src="../../../../public/static/image/elTree/1.9.png"
                  v-show="node.data.type=='group'&&node.data.unitid!=''" />
                <img src="../../../../public/static/image/elTree/2.0.png"
                  v-show="node.data.type=='group'&&node.data.unitid==''" />
                <img src="../../../../public/static/image/elTree/2.1.png" v-show="node.data.type=='virtualDevice'" />
                <span style="padding: 5px;">{{node.label }}</span>
              </span>
            </el-tree>
          </el-scrollbar>
        </div>
      </div>
    </transition>
  </div>
</template>
<script>
  export default {
    components: {},
    props: {
      dataList: {
        type: Array,
        required: true,
        default: []
      },
    },
    data () {
      return {
        filterText: '',
        data: [],
        defaultProps: {
          children: 'children',
          label: 'label'
        },
        isShow: true,
        defaultExpanded: [],
        defaultDevice: ""
      }
    },
    created () {
      // setTimeout(() => {
      // 	this.nodeClick()
      // },1000)
    },
    mounted () {
      if(!isempty(this.dataList)) {
        this.data=this.dataList
        this.digui(this.dataList)
      }
    },
    destroyed () {},
    computed: {
      bodyStyle () {
        let width='0px'
        if(this.isShow) {
          width='2.5rem'
        }
        return {
          "width": width
        }
      },
      getResourcesByName () {
        return this.$store.resourcesStore.getters.getResourcesByName
      },
      nowVirtualDevice () {
        return this.$store.deviceStore.state.nowVirtualDevice
      },
      nowDevice () {
        let nowDevice=this.nowVirtualDevice
        if(!isempty(nowDevice)) {
          nowDevice.label=nowDevice.name
        }
        return nowDevice
      },
      unitId () {
        return this.$store.unitStore.state.nowUnit
      },

    },
    watch: {
      filterText (val) {
        this.$refs.tree.filter(val);
      },
      unitId () {
        var data=this.$store.deviceStore.getters.getReadDeviceTree
        this.data=isempty(data)? []:[deviceList(data)]
        this.digui(this.data)
      },


    },
    methods: {
      setNowDefaultDevice (id) {
        // console.log("this.deviceArr",this.deviceArr);

        var arr=this.deviceArr.filter(item => item.id==id)
        arr[0].name=arr[0].label
        this.defaultDevice=arr[0].pkid
        this.defaultExpanded.push(arr[0].pkid)
        this.$nextTick(() => {
          //默认选中
          this.$refs['tree'].setCurrentKey(this.defaultDevice);
        })
      },
      filterNode (value,data) {
        if(!value) return true;
        return data.label.indexOf(value)!==-1;
      },
      nodeClick (value,nodeData) {
        // console.log("value.label",value);

        value.name=value.label
        // this.$emit('checkItem',value)
        this.$store.deviceStore.commit('setNowVirtualDevice',value)
      },
      digui (data) {
        this.defaultExpanded=[]
        // console.log("递归的数据",data);
        var device=[]
        var recursiveFunction=function() {
          const getStr=function(list) {
            list.forEach(function(row) {
              if(row.hasOwnProperty('children')&&row.children.length!=0) {
                getStr(row.children)
              } else {
                device.push(row)

              }
            })
          }
          getStr(data)
        }
        recursiveFunction()
        device[0].name=device[0].label
        console.log("device[0]",device[0]);
        this.deviceArr=device
        this.defaultExpanded.push(device[0].pkid)
        this.defaultDevice=device[0].pkid
        this.$nextTick(() => {
          //默认选中

          this.$refs['tree'].setCurrentKey(this.defaultDevice);
        })
        this.$emit('checkItem',device[0])
        this.$store.deviceStore.commit('setNowVirtualDevice',device[0])

      }
    }
  }
</script>

<style lang="scss">
  .el_Tree_Body .el-tree--highlight-current .el-tree-node.is-current>.el-tree-node__content {
    background-color: #bed5ef;

  }

  .el-tree-node__content {
    width: 100%;
  }

  .el-scrollbar .el-scrollbar__wrap {
    overflow-x: hidden;
  }

  .el-scrollbar__wrap .el-scrollbar__view {
    width: 100%;
    white-space: nowrap;
    display: inline-block;
  }

  .el_Tree_Body {
    // padding: 0 !important;
    //     height: 94.5% !important;
    // 	border-top: 0 !important;
    // 	border-bottom: 0 !important;
    // width: 2.65rem;
    // min-width: 2.55rem;
    position: relative;
    transition: 0.5s;
    background-color: #fff;
    height: 94.5%;

  }

  // /deep/.el-tree {
  // 	 width: 2.65rem !important;
  //      min-width: 2.55rem !important;
  // }
</style>